export const Second = () => {
  return (
    <svg
      width={449}
      height={274}
      viewBox="0 0 449 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={449}
        height={274}
      >
        <path
          d="M436.696 0H11.469C5.135 0 0 5.135 0 11.47V261.61c0 6.334 5.135 11.469 11.47 11.469h425.226c6.334 0 11.469-5.135 11.469-11.469V11.469C448.165 5.135 443.03 0 436.696 0z"
          fill="url(#paint0_linear_6778_774)"
          opacity={0.2}
        />
      </mask>
      <g mask="url(#a)">
        <mask
          id="b"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={-15}
          y={-119}
          width={466}
          height={419}
        >
          <path
            d="M450.778-118.901H-14.373v418.113h465.151v-418.113z"
            fill="#fff"
          />
        </mask>
        <g
          style={{
            mixBlendMode: "soft-light",
          }}
          opacity={0.85}
          mask="url(#b)"
        >
          <path
            d="M-14.373 131.363v38.662h38.645l-38.645-38.662zM62.918 131.363v38.662h38.62l-38.62-38.662z"
            fill="#939598"
          />
          <path
            d="M217.472 208.688v-38.663h-38.645l38.645 38.663zM294.763 208.688v38.663h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M333.407 247.351v38.638h38.62l-38.62-38.638z"
            fill="#D2D3D4"
          />
          <path d="M372.027 92.7V54.062h-38.62l38.62 38.638z" fill="#6E6F72" />
          <path
            d="M24.272 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#818285"
          />
          <path
            d="M-14.373 247.351v38.663h38.645l-38.645-38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M24.272 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M-14.373 208.688v38.663h38.645l-38.645-38.663zM24.272 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M-14.373 170.025v38.663h38.645l-38.645-38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M24.272 170.025v-38.662h-38.645l38.645 38.662zM24.272 131.363V92.7h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path d="M-14.373 92.7v38.663h38.645L-14.373 92.7z" fill="#D2D3D4" />
          <path d="M24.272 92.7V54.037h-38.645L24.272 92.7z" fill="#6E6F72" />
          <path
            d="M-14.373 54.037V92.7h38.645l-38.645-38.663z"
            fill="#939598"
          />
          <path
            d="M24.272 54.037V15.399h-38.645l38.645 38.638z"
            fill="#D2D3D4"
          />
          <path
            d="M-14.373 15.4v38.637h38.645l-38.645-38.638z"
            fill="#D2D3D4"
          />
          <path d="M24.272 15.4v-38.664h-38.645L24.272 15.4z" fill="#A8AAAD" />
          <path
            d="M-14.373-23.264V15.4h38.645l-38.645-38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M62.918 285.989v-38.638H24.273l38.645 38.638z"
            fill="#D2D3D4"
          />
          <path
            d="M24.273 247.351v38.663l38.645-.025-38.645-38.638z"
            fill="#BDBEC0"
          />
          <path
            d="M62.918 247.351v-38.663H24.273l38.645 38.663zM24.273 208.688v38.663h38.645l-38.645-38.663z"
            fill="#939598"
          />
          <path
            d="M62.918 170.025v-38.662H24.273l38.645 38.662z"
            fill="#E7E7E7"
          />
          <path
            d="M24.273 131.363v38.662h38.645l-38.645-38.662z"
            fill="#818285"
          />
          <path d="M62.918 131.363V92.7H24.273l38.645 38.663z" fill="#6E6F72" />
          <path
            d="M24.273 92.7v38.663h38.645L24.273 92.7zM62.918 92.7V54.062l-38.645-.025L62.918 92.7z"
            fill="#939598"
          />
          <path d="M24.273 54.037V92.7h38.645L24.273 54.037z" fill="#D2D3D4" />
          <path
            d="M62.918 54.062V15.399H24.273l38.645 38.663z"
            fill="#595A5C"
          />
          <path
            d="M24.273 15.4v38.637l38.645.025-38.645-38.663z"
            fill="#939598"
          />
          <path d="M62.918 15.4v-38.664H24.273L62.918 15.4z" fill="#818285" />
          <path d="M24.273-23.264V15.4h38.645L24.273-23.264z" fill="#D2D3D4" />
          <path
            d="M101.538 285.989v-38.638h-38.62l38.62 38.638z"
            fill="#E7E7E7"
          />
          <path
            d="M62.918 247.351v38.638h38.62l-38.62-38.638z"
            fill="#939598"
          />
          <path
            d="M101.538 247.351v-38.663h-38.62l38.62 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M62.918 208.688v38.663h38.62l-38.62-38.663z"
            fill="#818285"
          />
          <path
            d="M101.538 208.688v-38.663h-38.62l38.62 38.663z"
            fill="#939598"
          />
          <path
            d="M62.918 170.025v38.663h38.62l-38.62-38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M101.538 170.025v-38.662h-38.62l38.62 38.662z"
            fill="#D2D3D4"
          />
          <path d="M101.538 131.363V92.7h-38.62l38.62 38.663z" fill="#F2F2F2" />
          <path d="M62.918 92.7v38.663h38.62L62.918 92.7z" fill="#F2F2F2" />
          <path d="M101.538 92.7V54.062h-38.62l38.62 38.638z" fill="#A8AAAD" />
          <path d="M62.918 54.062V92.7h38.62l-38.62-38.638z" fill="#D2D3D4" />
          <path
            d="M101.538 54.062V15.399h-38.62l38.62 38.663z"
            fill="#6E6F72"
          />
          <path d="M62.918 15.4v38.662h38.62l-38.62-38.663z" fill="#E7E7E7" />
          <path d="M101.538 15.4v-38.664h-38.62l38.62 38.663z" fill="#D2D3D4" />
          <path d="M62.918-23.264V15.4h38.62l-38.62-38.663z" fill="#A8AAAD" />
          <path
            d="M140.181 285.989v-38.638h-38.645l38.645 38.638z"
            fill="#D2D3D4"
          />
          <path
            d="M101.536 247.351v38.638h38.645l-38.645-38.638z"
            fill="#A8AAAD"
          />
          <path
            d="M140.181 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#595A5C"
          />
          <path
            d="M101.536 208.688v38.663h38.645l-38.645-38.663z"
            fill="#F2F2F2"
          />
          <path
            d="M140.181 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M101.536 170.025v38.663h38.645l-38.645-38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M140.181 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#6E6F72"
          />
          <path
            d="M101.536 131.363v38.662h38.645l-38.645-38.662z"
            fill="#6E6F72"
          />
          <path
            d="M140.181 131.363V92.7h-38.645l38.645 38.663z"
            fill="#818285"
          />
          <path
            d="M101.536 92.7v38.663h38.645L101.536 92.7zM140.181 92.7V54.062h-38.645L140.181 92.7z"
            fill="#F2F2F2"
          />
          <path
            d="M101.536 54.062V92.7h38.645l-38.645-38.638z"
            fill="#E7E7E7"
          />
          <path
            d="M140.181 54.062V15.399h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M101.536 15.4v38.662h38.645l-38.645-38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M140.181 15.4v-38.664h-38.645L140.181 15.4z"
            fill="#818285"
          />
          <path
            d="M101.536-23.264V15.4h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M178.828 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M140.183 247.351v38.638l38.645.025-38.645-38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M178.828 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M140.183 208.688v38.663h38.645l-38.645-38.663z"
            fill="#6E6F72"
          />
          <path
            d="M178.828 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#595A5C"
          />
          <path
            d="M140.183 170.025v38.663h38.645l-38.645-38.663z"
            fill="#F2F2F2"
          />
          <path
            d="M178.828 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#BDBEC0"
          />
          <path
            d="M140.183 131.363v38.662h38.645l-38.645-38.662z"
            fill="#A8AAAD"
          />
          <path
            d="M178.828 131.363V92.7h-38.645l38.645 38.663z"
            fill="#818285"
          />
          <path d="M140.183 92.7v38.663h38.645L140.183 92.7z" fill="#818285" />
          <path d="M178.828 92.7V54.062h-38.645L178.828 92.7z" fill="#E7E7E7" />
          <path
            d="M140.183 54.062V92.7h38.645l-38.645-38.638zM178.828 54.062V15.399h-38.645l38.645 38.663z"
            fill="#939598"
          />
          <path
            d="M140.183 15.4v38.662h38.645l-38.645-38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M178.828 15.4v-38.664h-38.645L178.828 15.4z"
            fill="#D2D3D4"
          />
          <path
            d="M140.183-23.264V15.4h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M217.472 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M178.827 247.351v38.663h38.645l-38.645-38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M217.472 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M178.827 208.688v38.663h38.645l-38.645-38.663zM178.827 170.025v38.663h38.645l-38.645-38.663z"
            fill="#939598"
          />
          <path
            d="M217.472 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#E7E7E7"
          />
          <path
            d="M178.827 131.363v38.662h38.645l-38.645-38.662z"
            fill="#6E6F72"
          />
          <path
            d="M217.472 131.363V92.7h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path d="M178.827 92.7v38.663h38.645L178.827 92.7z" fill="#939598" />
          <path d="M217.472 92.7V54.062h-38.645L217.472 92.7z" fill="#595A5C" />
          <path
            d="M178.827 54.062V92.7h38.645l-38.645-38.638z"
            fill="#BDBEC0"
          />
          <path
            d="M217.472 54.062V15.399h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M178.827 15.4v38.662h38.645l-38.645-38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M256.118 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M217.473 247.351v38.663h38.645l-38.645-38.663zM256.118 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M217.473 170.025v38.663h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M256.118 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#939598"
          />
          <path
            d="M217.473 131.363v38.662h38.645l-38.645-38.662z"
            fill="#A8AAAD"
          />
          <path
            d="M256.118 131.363V92.7h-38.645l38.645 38.663z"
            fill="#818285"
          />
          <path d="M217.473 92.7v38.663h38.645L217.473 92.7z" fill="#939598" />
          <path d="M256.118 92.7V54.062h-38.645L256.118 92.7z" fill="#6E6F72" />
          <path
            d="M217.473 54.062V92.7h38.645l-38.645-38.638zM256.118 54.062V15.399h-38.645l38.645 38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M217.473 15.4v38.662h38.645l-38.645-38.663z"
            fill="#6E6F72"
          />
          <path
            d="M256.118 15.4v-38.664h-38.645L256.118 15.4z"
            fill="#939598"
          />
          <path
            d="M217.473-23.264V15.4h38.645l-38.645-38.663zM294.762 285.989v-38.638h-38.645l38.645 38.638zM256.117 247.351v38.663l38.645-.025-38.645-38.638z"
            fill="#6E6F72"
          />
          <path
            d="M294.762 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#939598"
          />
          <path
            d="M256.117 208.688v38.663h38.645l-38.645-38.663z"
            fill="#595A5C"
          />
          <path
            d="M294.762 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M256.117 170.025v38.663h38.645l-38.645-38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M294.762 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#BDBEC0"
          />
          <path
            d="M256.117 131.363v38.662h38.645l-38.645-38.662z"
            fill="#BDBEC0"
          />
          <path
            d="M294.762 131.363V92.7h-38.645l38.645 38.663z"
            fill="#A8AAAD"
          />
          <path d="M256.117 92.7v38.663h38.645L256.117 92.7z" fill="#D2D3D4" />
          <path d="M294.762 92.7V54.062h-38.645L294.762 92.7z" fill="#BDBEC0" />
          <path
            d="M256.117 54.062V92.7h38.645l-38.645-38.638z"
            fill="#6E6F72"
          />
          <path
            d="M294.762 54.062V15.399h-38.645l38.645 38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M256.117 15.4v38.662h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M294.762 15.4v-38.664h-38.645L294.762 15.4z"
            fill="#BDBEC0"
          />
          <path
            d="M256.117-23.264V15.4h38.645l-38.645-38.663z"
            fill="#6E6F72"
          />
          <path
            d="M333.408 285.989v-38.638h-38.645l38.645 38.638z"
            fill="#A8AAAD"
          />
          <path
            d="M294.763 247.351v38.638h38.645l-38.645-38.638z"
            fill="#E7E7E7"
          />
          <path
            d="M333.408 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#939598"
          />
          <path
            d="M333.408 208.688v-38.663h-38.645l38.645 38.663zM294.763 170.025v38.663h38.645l-38.645-38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M333.408 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#A8AAAD"
          />
          <path
            d="M294.763 131.363v38.662h38.645l-38.645-38.662z"
            fill="#6E6F72"
          />
          <path
            d="M333.408 131.363l-.025-38.663h-38.62l38.645 38.663zM294.763 92.7v38.663h38.645L294.763 92.7zM333.383 92.7l.025-38.638h-38.645l38.62 38.638z"
            fill="#939598"
          />
          <path d="M294.763 54.062V92.7h38.62l-38.62-38.638z" fill="#E7E7E7" />
          <path
            d="M333.408 54.062V15.399h-38.645l38.645 38.663z"
            fill="#939598"
          />
          <path
            d="M294.763 15.4v38.662h38.645l-38.645-38.663z"
            fill="#A8AAAD"
          />
          <path
            d="M333.408 15.4v-38.664h-38.645L333.408 15.4z"
            fill="#BDBEC0"
          />
          <path
            d="M294.763-23.264V15.4h38.645l-38.645-38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M372.027 285.989v-38.638h-38.62l38.62 38.638z"
            fill="#6E6F72"
          />
          <path
            d="M372.027 247.351v-38.663h-38.62l38.62 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M333.407 208.688v38.663h38.62l-38.62-38.663z"
            fill="#818285"
          />
          <path
            d="M372.027 208.688v-38.663h-38.62l38.62 38.663z"
            fill="#939598"
          />
          <path
            d="M333.407 170.025v38.663h38.62l-38.62-38.663z"
            fill="#F2F2F2"
          />
          <path
            d="M372.027 170.025v-38.662h-38.62l38.62 38.662z"
            fill="#6E6F72"
          />
          <path
            d="M333.407 131.363v38.662h38.62l-38.62-38.662z"
            fill="#818285"
          />
          <path
            d="M372.028 131.363V92.7h-38.645l38.645 38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M333.383 92.7l.025 38.663h38.62L333.383 92.7zM333.408 54.062l-.025 38.638h38.645l-38.62-38.638z"
            fill="#BDBEC0"
          />
          <path
            d="M372.027 54.062V15.399h-38.62l38.62 38.663z"
            fill="#E7E7E7"
          />
          <path d="M333.407 15.4v38.662h38.62l-38.62-38.663z" fill="#F2F2F2" />
          <path d="M372.027 15.4v-38.664h-38.62l38.62 38.663z" fill="#A8AAAD" />
          <path d="M333.407-23.264V15.4h38.62l-38.62-38.663z" fill="#6E6F72" />
          <path
            d="M410.672 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#595A5C"
          />
          <path
            d="M372.027 247.351v38.638l38.645.025-38.645-38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M410.672 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M372.027 170.025v38.663h38.645l-38.645-38.663z"
            fill="#939598"
          />
          <path
            d="M410.672 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#F2F2F2"
          />
          <path
            d="M372.027 131.363v38.662h38.645l-38.645-38.662z"
            fill="#BDBEC0"
          />
          <path
            d="M410.672 131.363V92.7h-38.645l38.645 38.663z"
            fill="#D2D3D4"
          />
          <path d="M372.027 92.7v38.663h38.645L372.027 92.7z" fill="#595A5C" />
          <path
            d="M410.672 92.7V54.062h-38.645L410.672 92.7zM372.027 54.062V92.7h38.645l-38.645-38.638z"
            fill="#BDBEC0"
          />
          <path
            d="M410.672 54.062V15.399h-38.645l38.645 38.663zM372.027 15.4v38.662h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M410.672 15.4v-38.664h-38.645L410.672 15.4z"
            fill="#939598"
          />
          <path
            d="M372.027-23.264V15.4h38.645l-38.645-38.663z"
            fill="#F2F2F2"
          />
          <path
            d="M449.318 286.014v-38.663h-38.645l38.645 38.663z"
            fill="#BDBEC0"
          />
          <path
            d="M410.673 247.351v38.663h38.645l-38.645-38.663z"
            fill="#D2D3D4"
          />
          <path
            d="M449.318 247.351v-38.663h-38.645l38.645 38.663z"
            fill="#F2F2F2"
          />
          <path
            d="M410.673 208.688v38.663h38.645l-38.645-38.663z"
            fill="#818285"
          />
          <path
            d="M449.318 208.688v-38.663h-38.645l38.645 38.663z"
            fill="#6E6F72"
          />
          <path
            d="M410.673 170.025v38.663h38.645l-38.645-38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M449.318 170.025v-38.662h-38.645l38.645 38.662z"
            fill="#A8AAAD"
          />
          <path
            d="M410.673 131.363v38.662h38.645l-38.645-38.662z"
            fill="#D2D3D4"
          />
          <path
            d="M449.318 131.363V92.7h-38.645l38.645 38.663z"
            fill="#A8AAAD"
          />
          <path d="M410.673 92.7v38.663h38.645L410.673 92.7z" fill="#595A5C" />
          <path d="M449.318 92.7V54.062h-38.645L449.318 92.7z" fill="#E7E7E7" />
          <path
            d="M410.673 54.062V92.7h38.645l-38.645-38.638z"
            fill="#A8AAAD"
          />
          <path
            d="M449.318 54.062V15.399h-38.645l38.645 38.663z"
            fill="#E7E7E7"
          />
          <path
            d="M410.673 15.4v38.662h38.645l-38.645-38.663zM449.318 15.4v-38.664h-38.645L449.318 15.4z"
            fill="#D2D3D4"
          />
          <path
            d="M410.673-23.264V15.4h38.645l-38.645-38.663z"
            fill="#D2D3D4"
          />
        </g>
        <g
          style={{
            mixBlendMode: "soft-light",
          }}
        >
          <path
            d="M-13.446 33.993c.822-4.172 1.464-8.392 2.489-12.513C-3.748-7.472 23.3-26.194 49.755-26.12c83.778.243 265.007.284 348.788-.012 30.707-.107 58.684 23.873 62.397 54.513.358 2.957.638 5.947.642 8.923.033 83.362.03 166.72.026 250.081 0 35.558-27.351 63.385-62.925 63.964-7.224.118-64.532.019-72.21.019 3.345-6.155 6.564-11.612 9.348-17.286 8.32-16.969 12.235-34.949 12.202-53.863-.074-43.632-.022-87.268-.022-130.903 0-59.11-40.297-111.144-97.808-124.45-42.787-9.898-80.577 1.55-112.541 31.352-21.03 19.605-33.387 44.223-38.111 72.567-1.106 6.641-1.608 13.45-1.682 20.187-.213 20.317-.1 40.638-.073 60.955.05 43.082 31.303 79.998 73.732 86.943 5.358.879 10.838 1.385 16.266 1.407 32.654.129 65.306.063 97.959.063h5.732c-1.859 4.873-3.068 9.362-5.185 13.376-12.036 22.816-30.703 36.281-56.593 38.629-9.422.857-18.954.631-28.438.679-33.948.166-115.274-.092-149.214.44-32.259.509-58.972-22.629-64.168-52.707-.442-2.537-.885-5.073-1.323-7.613V33.993z"
            fill="#00B9D1"
          />
          <path
            d="M235.877 243.502c-16.391 0-32.793-.362-49.173.096-18.914.525-34.343-16.138-34.036-33.752.376-21.617-.351-43.255.276-64.857.922-31.859 24.434-63.684 61.262-68.424 36.606-4.715 72.232 22.377 77.91 58.872.616 3.966.981 8.016.992 12.025.081 30.349-.022 60.697.126 91.045.018 3.939-1.099 5.124-5.06 5.08-17.431-.199-34.866-.085-52.297-.085z"
            fill="#fff"
            fillOpacity={0.68}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6778_774"
          x1={0}
          y1={273.08}
          x2={448.165}
          y2={273.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#149CB9" />
          <stop offset={1} stopColor="#0CACA3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
